export default {"src":"/_next/static/media/Emails, Letter, Mail.6e29eb9c.svg","height":20,"width":22};